export default "__VITE_ASSET__f3ac6237__"